var map = {
	"./assignment-advanced-controller.js": 353,
	"./assignment-advanced-controller.js.coffee": 353,
	"./assignment-assignments-controller.js": 354,
	"./assignment-assignments-controller.js.coffee": 354,
	"./assignment-details-controller.js": 355,
	"./assignment-details-controller.js.coffee": 355,
	"./assignment-instructional-items-controller.js": 356,
	"./assignment-instructional-items-controller.js.coffee": 356,
	"./assignment-memories-controller.js": 357,
	"./assignment-memories-controller.js.coffee": 357,
	"./course-assignments-controller.js": 358,
	"./course-assignments-controller.js.coffee": 358,
	"./course-details-controller.js": 359,
	"./course-details-controller.js.coffee": 359,
	"./course-instructional-items-controller.js": 360,
	"./course-instructional-items-controller.js.coffee": 360,
	"./dashboard-controller.js": 361,
	"./dashboard-controller.js.coffee": 361,
	"./instructional-item-show-controller.js": 362,
	"./instructional-item-show-controller.js.coffee": 362,
	"./learn-dashboard-lti-redirect-controller": 363,
	"./learn-dashboard-lti-redirect-controller.ts": 363,
	"./learning-library-controller.js": 364,
	"./learning-library-controller.js.coffee": 364,
	"./library-controller.js": 365,
	"./library-controller.js.coffee": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;